<template>
  <div class="mission_ongoing_800">
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="confirmDialogConfirmFunction()">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <confirm-dialog ref="confirmSendingOtherCode">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4" style="color: white"
          @click="acceptSendingToOtherCodeConfirmation()">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn mx-2"
          @click="cancelSendingOtherCodeConfirmation()">
          خیر
        </v-btn>
        <v-btn elevation="0" small rounded color="grey lighten-3" class="normal-letter-spacing px-10"
          @click="ignoreSendingOtherCodeConfirmation()">
          انصراف
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-dialog v-model="otherOrganModal" width="400" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-2">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-office-building</v-icon>
              <span class="modal-title-text mr-2">سازمان های همکار</span>
              <v-spacer></v-spacer>
              <v-icon class="ml-3" @click="closeOtherOrganModal()">mdi-close</v-icon>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-8">
          <v-row>
            <v-col cols="12">
              <v-row>
                <span>درخواست ها و پیشنهادات</span>
                <v-divider class="mt-3 mr-3"></v-divider>
              </v-row>
              <v-row>
                <v-col cols="12" v-for="item in allMissionOtherOrganizationRequests" :key="'s' + item.id">
                  <v-card elevation="0" class="other-organ-sugest-card-part">
                    <span class="other-organ-sugest-user">
                      {{ item.user.firstName }} {{ item.user.lastName }}
                    </span>
                    <v-card-text>
                      <v-row>
                        <v-chip small class="mr-2 mt-1 mb-1" v-for="subItem in item.requests" :key="'wi' + subItem.id">
                          {{ subItem.otherOrganization.title }}
                        </v-chip>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <span>سازمان های انتخابی</span>
                <v-divider class="mt-3 mr-3"></v-divider>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card height="25vh" elevation="0" class="other-organ-selected-card-part">
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <v-autocomplete :items="allOtherOrganizationsForOther" no-data-text="اطلاعاتی وجود ندارد"
                            dense outlined item-text="title" item-value="id" label="سازمان همکار" clearable
                            clear-icon="mdi-close-circle-outline" v-model="selectedOtherOrgan" autocomplete="off"
                            prepend-inner-icon="mdi-office-building mdi-18px">
                            <template v-slot:append-outer>
                              <v-btn x-small elevation="0" color="darkColor" class="py-5 mt-n2"
                                @click="addSeletctedOtherOrgan()">
                                <v-icon color="white">mdi-plus mdi-18px</v-icon>
                              </v-btn>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" class="mt-n10">
                          <v-row>
                            <v-col cols="12" v-for="item in allMissionOtherOrganizationInforms" :key="item.id">
                              <span class="mr-2 mt-2 other-organ-selected-span">
                                {{ item.otherOrganization.title }}
                                <v-icon class="mr-4" @click="deleteMissionOtherOrganizationInformFunction(item.id)">
                                  mdi-close-circle mdi-18px
                                </v-icon>
                              </span>
                              <v-icon color="darkColor" class="mr-2"
                                @click="callToOtherOrgan(item.otherOrganization.phoneNumber)">
                                mdi-phone mdi-flip-h mdi-18px
                              </v-icon>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="attachmentModal" width="750">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <span class="modal-title-text mr-2">{{ attachmentModalTitle }}</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="5" class="mt-2">
              <v-text-field placeholder="کد" rounded outlined dense v-model="searchTextCode_Attach"></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="5" class="mt-2">
              <v-text-field placeholder="جستجو..." rounded outlined dense v-model="attachmentListSearch"></v-text-field>
            </v-col>
            <v-col cols="12" class="mt-n4">
              <template>
                <v-data-table :headers="attachmentCurrentMissionListHeader" :items="attachallFilterList"
                  :items-per-page="attachallFilterList.length" height="45vh" :hide-default-footer="true"
                  :search="attachmentListSearch" multi-sort class="elevation-0" @click:row="attachmentTableClick">
                  <template v-slot:[`item.check`]="{ item }">
                    <v-checkbox v-if="item.check == true || item.check == false" v-model="item.check"
                      @click="attachmentTableClick(item)" hide-details></v-checkbox>
                  </template>
                  <template v-slot:no-data>
                    <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                  </template>
                </v-data-table>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <v-btn color="darkColor" @click="attachMissionBy800UserFunction()" dark rounded
              class="normal-letter-spacing px-12 ml-5">
              ثبت
            </v-btn>
            <v-btn rounded color="darkColor" outlined @click="cancelAttachment()" class="normal-letter-spacing px-10">
              انصراف
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deletemodal" width="400" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-delete</v-icon>
              <span class="modal-title-text mr-2">حذف ماموریت</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-8">
          <v-row>
            <v-col cols="12">
              <v-autocomplete :items="allCancelReasonsForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                item-text="note" item-value="value" label="علل حذف" clearable clear-icon="mdi-close-circle-outline"
                v-model="selectedReason" @change="cancelReasonChanged()" autocomplete="off"
                prepend-inner-icon="mdi-delete mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-textarea outlined label="توضیحات" dense clearable rows="4" clear-icon="mdi-close-circle-outline"
                v-model="removeReason" prepend-inner-icon="mdi-text mdi-18px"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="removeMissionBy800UserFunction()" dark rounded
            class="normal-letter-spacing px-12">
            حذف
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelRemoveMission()" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <termineh-modal :is-modal-open="isTerminehModalOpen" :mission-id="missionId"
      :all-universities-list="universitiesList" @close-modal="closeTerminehModal" @on-success="closeSendToPhoneModal" />

    <div class="mainBox">
      <div class="listitemsBox">
        <template v-if="!sendTOPhoneModal">
          <div class="reloadApi">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="ml-3" size="16" :color="silentTopListSound ? '#ff0000' : '#464646'"
                  @click="handleAlarmTopListManual()" v-bind="attrs" v-on="on">
                  {{ silentTopListSound ? 'mdi-bell-off-outline' : 'mdi-bell-outline' }}
                </v-icon>
              </template>
              <span>{{ silentTopListSound ? 'صدای هشدار خاموش' : 'صدای هشدار روشن' }}</span>
            </v-tooltip>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="ml-1" :class="{ 'refresh-btn': isTopListLoading }" v-bind="attrs" v-on="on"
                  @click="refreshTopListManual()">
                  mdi-cached mdi-18px
                </v-icon>
              </template>
              <span>به روز رسانی</span>
            </v-tooltip>
            <span class="s1">ماموریت های جدید</span>
          </div>
          <div class="list">
            <div v-if="isTopListLoading" class="text-center pa-10">
              <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
              <p class="mt-4">در حال دریافت اطلاعات...</p>
            </div>
            <div v-else-if="currentMission800TopList?.length == 0" class="emptyList">
              <v-icon color="#B6B6B6" size="48px">mdi-notification-none</v-icon>
              <span class="txt2 mt-4">ماموریت جدیدی دریافت نشد</span>
            </div>
            <div v-else class="item" v-for="(item, index) in currentMission800TopList" :key="item.id || index"
              @dblclick="showSendToPhoneModal(null, { item: item ?? {} })" @click="stopSound2"
              :style="{ borderColor: item?.iconColor || '#ccc', background: item?.iconClass === '10-19' ? '#ffdac1' : '' }">
              <div class="titleTop" :class="item?.afterStyle_new800 ?? ''"
                :style="{ background: item?.iconColor || '' }">

                <v-icon color="#FfD700" size="13px" style="margin-left: -5px;"
                  v-if="item?.missionIsStarred_Item">mdi-star</v-icon>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span class="txt1" v-on="on">{{ item?.cc_only }}</span>
                  </template>
                  تشخص پرستار
                </v-tooltip>
                <div class="suggIconBox">
                  <div class="iconNum" v-for="(i, index2) in item?.mission115Suggestions" :key="index2">
                    <v-icon color="#fff" size="16px">{{ getVehicleIcon(i?.title) }}</v-icon>
                    <div class="tNum">
                      <span :style="{ color: item?.iconColor || '' }">{{ i?.count }}</span>
                    </div>
                  </div>
                </div>
                <span class="txt3">{{ item?.reciveTime ?? '' }}</span>
              </div>
              <div class="txtAddress" v-if="item?.iconClass == '10-19'">
                <div class="icons ml-3">
                  <v-icon color="#ff0000" v-on="on" size="20px" style="margin-left: -5px;">mdi-close-octagon</v-icon>
                </div>
                <p v-on="on" class="txt2" style="color: #ff0000;">
                  وضعیت 19-10
                </p>
              </div>
              <div class="txtAddress">
                <div class="icons">
                  <v-icon :color="handleIconLocation(item?.locationState)?.color" size="18px">
                    {{ handleIconLocation(item?.locationState)?.icon }}
                  </v-icon>
                </div>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <p class="txt2" v-on="on">
                      {{ item?.city ?? '' }} &nbsp;
                      {{ item?.address ?? '' }}
                    </p>
                  </template>
                  آدرس
                </v-tooltip>
              </div>
              <div class="txtAddress">
                <div class="icons">
                  <v-icon color="#6b6b6b" size="18px">mdi-text</v-icon>
                </div>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <p v-on="on" class="txt2">
                      {{ item?.chiefComplaintText_only ?? '' }}
                    </p>
                  </template>
                  شکایت اصلی
                </v-tooltip>
              </div>
              <v-divider class="mt-1 mb-1"></v-divider>
              <div class="txtDetil">
                <v-icon color="#B6B6B6" size="16px">mdi-phone</v-icon>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <div class="phoneBox" v-on="on">
                      <span class="txtPhone" v-for="(ph, index) in item?.customPhoneList" :key="index" @click="
                        callToPatient(ph, false, {
                          missionId: item?.id,
                          missionPhoneId: null,
                          to: ph,
                        })">
                        {{ ph }}
                        <span v-if="index < item?.customPhoneList?.length - 1"> - </span>
                      </span>
                      <span v-if="!item?.customPhoneList?.length">- -</span>
                    </div>
                  </template>
                  تلفن پیگیری
                </v-tooltip>
              </div>
              <div class="moreDetil">
                <div class="txtZone">
                  <v-icon color="#B6B6B6" size="16px">mdi-map-marker-radius</v-icon>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span class="txt1" v-on="on">{{ item?.zone ?? '' }}</span>
                    </template>
                    ناحیه
                  </v-tooltip>
                </div>
                <div class="txtUser">
                  <v-icon color="#B6B6B6" size="16px">mdi-account</v-icon>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span class="txt1" v-on="on">{{ item?.user ?? '' }}</span>
                    </template>
                    کاربر ایجاد کننده
                  </v-tooltip>
                </div>
              </div>
            </div>

          </div>
        </template>
        <template v-else>
          <div class="reloadApi" @click="closeSendToPhoneModal()">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="ml-1" v-bind="attrs" v-on="on">
                  mdi-arrow-right mdi-18px
                </v-icon>
              </template>
              <span>بازگشت</span>
            </v-tooltip>
            <span class="s1">بازگشت</span>
          </div>
          <div class="selectItemList">
            <div v-if="missionSendInfoNew === null" class="text-center pa-10">
              <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
              <p class="mt-4">در حال دریافت اطلاعات...</p>
            </div>
            <div v-else-if="missionSendInfoNew == {}" class="emptyList">
              <v-icon color="#B6B6B6" size="48px">mdi-notification-none</v-icon>
              <span class="txt2 mt-4">اطلاعاتی دریافت نشد</span>
            </div>
            <div v-else class="item" :style="{ borderColor: missionSendInfoNew?.iconColor || '' }">
              <div class="titleTop" :class="missionSendInfoNew?.afterStyle_new800 ?? ''"
                :style="{ background: missionSendInfoNew?.iconColor || '' }">
                <span class="txt1" style="margin-left: auto;">{{ missionSendInfoNew?.cc_only }}</span>

                <v-menu rounded="lg" offset-y="true">
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-icon color="#fff" size="16px" style="cursor: pointer" v-bind="attrs"
                          v-on="{ ...tooltip, ...menu }">
                          mdi-phone
                        </v-icon>
                      </template>
                      <span>تماس</span>
                    </v-tooltip>
                  </template>
                  <v-list>
                    <v-list-item class="itemCallStyle" dense
                      v-for="(callItem, index) in missionSendInfoNew?.patiantPhoneNumbers" :key="index + '-c'"
                      @click="callToPatient(callItem)">
                      <v-list-item-icon style="margin-top: 0;margin-bottom: 0;">
                        <v-icon color="iconColor" size="16px">mdi-phone</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="fontFamilySET">{{ callItem }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="#fff" size="16px" v-bind="attrs" v-on="on" @click="showDeleteModal()">
                      mdi-trash-can
                    </v-icon>
                  </template>
                  <span>حذف</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="#fff" size="16px" v-bind="attrs" v-on="on" @click="showOtherOrganModal()">
                      mdi-office-building
                    </v-icon>
                  </template>
                  <span>سازمان همکار</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="#fff" size="16px" v-bind="attrs" v-on="on" @click="openTerminehModal">
                      mdi-email-arrow-right
                    </v-icon>
                  </template>
                  <span>ترمینه</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon @click="openAttachmentModal" color="#fff" size="16px" v-bind="attrs" v-on="on">
                      mdi-paperclip
                    </v-icon>
                  </template>
                  <span>پیوست</span>
                </v-tooltip>
                <v-tooltip top v-if="missionIsStarred == false">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="#fff" size="16px" v-bind="attrs" v-on="on"
                      @click="starredMissionBy800UserFunction()">
                      mdi-star-outline
                    </v-icon>
                  </template>
                  <span>ستاره دار کردن</span>
                </v-tooltip>
                <v-tooltip top v-if="missionIsStarred == true">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="#FfD700" size="16px" v-bind="attrs" v-on="on"
                      @click="removeStarredMissionBy800UserFunction(missionSendInfoNew?.id)">mdi-star</v-icon>
                  </template>
                  <span>ستاره دار</span>
                </v-tooltip>
              </div>
              <div class="txtAddress" v-if="missionSendInfo.lastState">
                <div class="icons">
                  <v-icon color="#ff0000" v-on="on" size="20px" style="margin-left: -5px;">mdi-close-octagon</v-icon>
                </div>
                <p class="txt2" style="color: #ff0000;">
                  {{ missionSendInfo.lastState }}
                </p>
              </div>
              <div class="txtAddress">
                <div class="icons">
                  <v-icon :color="handleIconLocation(missionSendInfoNew?.locationState)?.color" size="18px">
                    {{ handleIconLocation(missionSendInfoNew?.locationState)?.icon }}
                  </v-icon>
                </div>
                <p class="txt2">
                  {{ missionSendInfoNew?.city ?? '' }} &nbsp;
                  {{ missionSendInfoNew?.address ?? '' }}
                </p>
              </div>
              <v-divider class="mt-1 mb-1"></v-divider>
              <div class="txtDetil">
                <v-icon color="#B6B6B6" size="16px">mdi-phone</v-icon>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <div class="phoneBox" v-on="on">
                      <span class="txtPhone" v-for="(ph, index) in missionSendInfoNew?.customPhoneList" :key="index"
                        @click="
                          callToPatient(ph, false, {
                            missionId: missionSendInfoNew?.id,
                            missionPhoneId: null,
                            to: ph,
                          })">
                        {{ ph }}
                        <span v-if="index < missionSendInfoNew?.customPhoneList?.length - 1"> - </span>
                      </span>
                      <span v-if="!missionSendInfoNew?.customPhoneList?.length">- -</span>
                    </div>
                  </template>
                  تلفن پیگیری
                </v-tooltip>
              </div>
              <div class="moreDetil">
                <div class="txtZone">
                  <v-icon color="#B6B6B6" size="16px">mdi-clock</v-icon>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span class="txt1" v-on="on">{{ missionSendInfoNew?.reciveTime ?? '' }}</span>
                    </template>
                    زمان دریافت
                  </v-tooltip>
                </div>
                <div class="txtUser">
                  <v-icon color="#B6B6B6" size="16px">mdi-ambulance</v-icon>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span class="txt1" v-on="on">{{ missionSendInfoNew?.code ?? '' }}</span>
                    </template>
                    کدهای پیشنهادی
                  </v-tooltip>
                </div>
              </div>
              <!-- <div class="moreDetil"> -->
              <!-- <div class="txtZone">
                  <v-icon color="#B6B6B6" size="16px">mdi-map-marker-radius</v-icon>
                  <span class="txt1">{{ missionSendInfoNew?.address ?? '' }}</span>
                </div> -->
              <!-- <div class="txtUser">
                  <v-icon color="#B6B6B6" size="16px">mdi-account</v-icon>
                  <span class="txt1">{{ missionSendInfoNew?.user ?? '' }}</span>
                </div> -->
              <!-- </div> -->
              <div class="txtUser" style="margin-bottom: 5px;">
                <v-icon color="#B6B6B6" size="16px"> mdi-office-building</v-icon>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span class="txt1" v-on="on">{{ missionSendInfoNew?.otherOrgan ?? '' }}</span>
                  </template>
                  سازمان های همکار
                </v-tooltip>
              </div>
              <div class="txtComplaint">
                <p class="txt3">
                  شکایت اصلی :
                </p>
                <p class="txt2">
                  {{ missionSendInfoNew?.chiefComplaintText_only ?? '' }}
                </p>
              </div>
              <div class="txtComplaint">
                <p class="txt3">
                  توضیحات شکایت :
                </p>
                <p class="txt2">
                  {{ missionSendInfoNew?.chiefComplaintNote_only ?? '' }}
                </p>
              </div>
              <v-divider class="mt-1 mb-1"></v-divider>
              <div class="btnSubmitToPhone">
                <v-autocomplete class="inputCode" :items="readyPhonesList" no-data-text="اطلاعاتی وجود ندارد" dense
                  outlined item-text="code" item-value="id" label="کد" clearable :autofocus="true" tabindex="1"
                  hide-details clear-icon="mdi-close-circle-outline" autocomplete="off" auto-select-first
                  prepend-inner-icon="mdi-file-document mdi-18px" v-model="selectedPhoneCode"
                  :filter="startsWithFilter">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-bind="attrs" v-on="on" class="custom-autocomplete-item">
                      <v-list-item-content>
                        <v-list-item-title>
                          <span class="item-code fontFamilySET">{{ item.code }}</span>
                          <span class="item-title fontFamilySET">{{ item.title }}</span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>

                <v-btn class="btnSubmit" rounded dark tabindex="2" color="darkColor" block
                  @click="sendMissionToPhoneCheckType()">
                  اعزام کد (F9)
                </v-btn>
              </div>
              <div class="mt-1 mb-1 d-flex align-center justify-start gap-2">
                <span style="font-size: 13px;">کدهای پیشنهادی</span>
                <v-divider class="w-full"></v-divider>
              </div>
              <v-row>
                <v-col cols="6" class="pl-1">
                  <v-card height="11vh" elevation="0" class="send-mission-detail-card">
                    <v-row no-gutters>
                      <span class="send-mission-title-content">نزدیک ترین کدها</span>
                    </v-row>
                    <v-card-text class="send-mission-detail-card-body">
                      <v-row v-if="topNearestLoaderFlag == false">
                        <v-chip @click="selectCodeFromAdvice(item)" class="mr-2 mt-2"
                          v-for="(item, index6) in topNearestCodeList" small color="background" :key="'w' + index6">
                          {{ item.code }} -
                          <span style="font-size: 11px">{{ item?.duration?.text ?? '' }}</span>
                        </v-chip>
                      </v-row>
                      <v-row v-else>
                        <v-col cols="12">
                          <v-progress-linear indeterminate color="lightColor" rounded height="8"></v-progress-linear>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6" class="pr-1">
                  <v-card height="11vh" elevation="0" class="send-mission-detail-card">
                    <v-row no-gutters>
                      <span class="send-mission-title-content">کدها بر اساس فنس</span>
                    </v-row>
                    <v-card-text class="send-mission-detail-card-body">
                      <v-row v-if="topNearestFenceLoaderFlag == false">
                        <v-chip @click="selectCodeFromAdvice(item)" class="mr-2"
                          v-for="(item, index7) in readyPhonesByStationList" small color="background"
                          :key="'ty' + index7">
                          {{ item.code }}
                        </v-chip>
                      </v-row>
                      <v-row v-else>
                        <v-col cols="12">
                          <v-progress-linear indeterminate color="lightColor" rounded height="8"></v-progress-linear>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <div class="mt-1 mb-1 d-flex align-center justify-start gap-2">
                <span style="font-size: 13px;">مناطق فاقد کد</span>
                <v-divider class="w-full"></v-divider>
              </div>
              <v-row>
                <v-col cols="12">
                  <v-card height="14vh" elevation="0" class="send-mission-detail-card">
                    <v-card-text class="send-mission-detail-card-body mt-2">
                      <v-row>
                        <v-col cols="10" class="mt-n5">
                          <v-autocomplete :items="allStationsForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                            item-text="titleCode" item-value="id" placeholder="انتخاب کد" autocomplete="off"
                            hide-details v-model="selectedMissionLakeCode" auto-select-first
                            @keydown.enter="handleEnterLack()"></v-autocomplete>
                        </v-col>
                        <v-col cols="2" class="mt-n4 mr-n4">
                          <v-btn color="darkColor" small class="py-3" block elevation="0" @click="addMissionLakeCode()">
                            <v-icon color="white">mdi-plus mdi-18px</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-chip close close-icon="mdi-close" style="margin-top: 6px; margin-right: 4px;"
                        @click:close="removeCodeFromMissionLakeOfCodeFunction(item.id)" small
                        v-for="(item, index5) in missionSendInfo.missionLackOfCodes" :key="'h' + index5">
                        {{ item.station ? item.station.title : '-' }}
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </div>
        </template>
      </div>

      <div class="mapViewBox">
        <div class="filtersControl">
          <div class="itemSearch">
            <map-search-field @address-search="onSearchSuggestion" :maxMinSearchProp="false" />
          </div>
          <div class="itemZone">
            <v-autocomplete hide-details :items="allZones" no-data-text="اطلاعاتی وجود ندارد" dense outlined rounded
              item-text="title" item-value="value" clearable clear-icon="mdi-close mdi-18px" multiple
              placeholder="ناحیه" label="ناحیه" autocomplete="off" class="current-mission-select custom-height-30"
              v-model="selectedZonesOngoing" color="primary" return-object>
              <template v-slot:label>
                <span class="custom-label">ناحیه</span>
              </template>
            </v-autocomplete>
          </div>
          <div class="itemCode">
            <v-text-field rounded hide-details clearable type="number" dense outlined clear-icon="mdi-close mdi-18px"
              placeholder="کد" v-on:keyup.enter="searchForCode()" class="custom-height-30" v-model="searchCode"
              @click:clear="clearSearchCode()">
              <template v-slot:label>
                <span class="custom-label">کد</span>
              </template>
            </v-text-field>
          </div>
        </div>
        <div class="mapBox" v-if="!sendTOPhoneModal">
          <l-map v-if="isMapReadyToShow" ref="modalmap" style="height: 100% !important" :zoom="zoom" :center="center"
            :options="mapOptions" @update:center="centerUpdate" @update:zoom="zoomUpdate" @ready="mapInvalidate()"
            @click="add800SelectedMarker">
            <l-tile-layer :url="mapTileUrl" :attribution="attribution"></l-tile-layer>
            <!--<v-geosearch :options="geosearchOptions"></v-geosearch>-->
            <l-control position="topright">
              <div>
                <div class="mb-3">
                  <v-btn icon small tile class="no-letter-space" @click="showHideFence()" style="
                      background-color: white;
                      border: solid;
                      border-width: 2px;
                      border-radius: 5px;
                      border-color: #c2bfba;
                      padding: 15px;
                    ">
                    <v-icon>mdi-layers</v-icon>
                  </v-btn>
                </div>
                <div>
                  <v-btn icon small tile class="no-letter-space" style="
                      background-color: white;
                      border: solid;
                      border-width: 2px;
                      border-radius: 5px;
                      border-color: #c2bfba;
                      padding: 15px;
                    " @click="toggleShowingStations">
                    <v-icon>mdi-home-group mdi-24px</v-icon>
                  </v-btn>
                </div>
              </div>
            </l-control>
            <template v-if="showingStationsList?.length">
              <l-marker v-for="station in showingStationsList" :key="station.id"
                :lat-lng="[station?.latitude, station?.longitude]" :icon="stationIcon()">
                <v-popup>
                  <div dir="rtl" class="mt-5">
                    <app-conversation question="نام پایگاه" :answer="station?.title"></app-conversation>
                    <app-conversation question="کد پایگاه" :answer="station?.code"></app-conversation>
                  </div>
                </v-popup>
                <!-- <l-icon
                  icon-url="/icons/map/shield-home.svg"
                  :icon-size="[22,22]"
                  :icon-anchor="[11,11]"
                >
                </l-icon> -->
              </l-marker>
            </template>
            <l-marker v-for="(item, index) in filteredPositions" :key="'pos-' + (item?.phone?.id ?? index)"
              :lat-lng="[item?.latitude, item?.longitude]" :icon="getMovingIcon(item)">
              <l-tooltip :options="{ permanent: true, interactive: true, direction: 'top' }" clsas="fontFamilySET">
                {{ item.phone && item.phone.code ? item.phone.code : '-' }}
              </l-tooltip>
              <!-- no :lat-lng (popup anchors to its marker) and autoPan:false ->
                   a data refresh can move the marker without panning the map -->
              <v-popup :options="{ autoPan: false }">
                <template v-for="({ value }, index) in getPopUpInfoList(item)">
                  <div v-if="value" :key="index" class="text-right mt-2 fontFamilySET">
                    {{ value }}
                  </div>
                </template>
              </v-popup>
            </l-marker>

            <l-polygon v-for="(item, index) in fenceCoords" :key="index" :lat-lngs="item.latlngs" :color="item.color"
              :fillColor="item.color">
              <v-popup :options="{ offset: [5, -8] }">
                <h4 class="mt-5 font-bold text-center fontFamilySET">{{ item.title }}</h4>
                <h4 v-if="item.moreInfo?.length > 0" style="font-weight: 400;direction: rtl;"
                  class="fontFamilySET text-right mt-2">
                  فاقدی ها : </h4>
                <v-list dense>
                  <v-list-item dense v-for="lake in item.moreInfo" :key="lake.id" class="mt-n3">
                    <!-- <v-list-item-icon>
                      <v-icon color="#ff0000" size="20px">mdi-close-octagon</v-icon>
                    </v-list-item-icon> -->
                    <v-list-item-title class="text-right fontFamilySET">{{ lake.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-popup>
            </l-polygon>
          </l-map>
        </div>
        <div class="mapBox" v-if="sendTOPhoneModal">
          <l-map v-if="isMapReadyToShow" ref="modalmap" style="height: 100% !important" :zoom="zoom" :center="center"
            :options="mapOptions" @update:center="centerUpdate" @update:zoom="zoomUpdate"
            @ready="on800DispatchMapReady()" @click="add800SelectedMarker">
            <l-tile-layer :url="mapTileUrl" :attribution="attribution"></l-tile-layer>
            <l-control position="topright">
              <v-btn icon small tile class="no-letter-space" @click="showHideFence()" style="
                                background-color: white;
                                border: solid;
                                border-width: 2px;
                                border-radius: 5px;
                                border-color: #c2bfba;
                                padding: 15px;
                              ">
                <v-icon>mdi-layers</v-icon>
              </v-btn>
            </l-control>
            <l-polygon @click="fenceClick($event, item)" v-for="(item, index2) in fence800Coords" :key="'hhk' + index2"
              :lat-lngs="item.latlngs" :color="item.color" :fillColor="item.color">
              <v-popup>
                <span class="ml-12">{{ item.title }}</span>
                <v-list dense>
                  <v-list-item dense v-for="(lake, index3) in item.moreInfo" :key="'j' + index3" class="mt-n6">
                    <v-list-item-title class="text-right fontFamilySET">
                      {{ lake.title }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-popup>
            </l-polygon>
            <!-- Marker -->
            <l-marker style="z-index: 9999999999999999999999999 !important"
              v-if="patiantPosition && patiantPosition.lat && patiantPosition.lng" :lat-lng.sync="patiantPosition"
              :icon="patientIcon" visible class="mapIcon">
              <v-popup>
                <div class="text-center mb-1">موقعیت مددجو</div>
                <div class="text-right">
                  {{ address }}
                </div>
              </v-popup>
            </l-marker>
            <l-marker v-if="
              selected800Position &&
              selected800Position.lat &&
              selected800Position.lng
            " visible draggable :lat-lng.sync="selected800Position" @dragstart="dragging = true"
              @dragend="dragging = false"></l-marker>
            <l-marker ref="marker29" v-for="(item, index4) in allPhoneOnlineLocations"
              :key="'r' + (item?.phone?.id ?? index4)" :lat-lng="[item.latitude, item.longitude]"
              :icon="getMovingIcon(item)">
              <!-- manual offset removed: the icon's tooltipAnchor now positions it -->
              <l-tooltip :options="{ permanent: true, interactive: true, direction: 'top' }">
                <div>
                  {{ item?.phone?.code }}
                </div>
              </l-tooltip>
            </l-marker>
          </l-map>
        </div>
      </div>

    </div>

    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>

<script>
import Vue from 'vue';
import L from 'leaflet';
import { latLng } from 'leaflet';
import throttle from 'lodash/throttle';
import 'leaflet/dist/leaflet.css';
import { LMap, LTileLayer, LMarker, LPolygon, LPopup, LTooltip, LControl } from 'vue2-leaflet';
import MapSearchField from '@/components/app/map/search.vue';
import confirmDialog from '../../components/ConfirmDialog.vue';
import AppConversation from '@/components/app/conversation.vue';
import AlertComponent from '../../components/AlertComponent.vue';
import SerachMapMixin from '@/components/app/map/SerachMapMixin.js';
import TerminehModal from '@/components/800/missionsView/termineh.modal.vue';

import ShearedHelper from '@/Helpers/Shared.js';
import MapHelper from '@/Helpers/800/Map.helper.js';
import Mission800HelperNewWithMap from '@/Helpers/800/800MissionHelperNewWithMap.js';

import SharedMap from '@/Mixins/map';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import MapMixin from '@/Mixins/115/MapMixin.js';
import CallMixin from '@/Mixins/Call/CallMixin.js';
import TerminehMixin from '@/Mixins/800/termineh.mixin';
import UserNotificationMixin from '@/Mixins/800/userNotification.mixin';
import ZoneMixin from '@/Mixins/BaseInformation/ZoneMixin';
import PhoneMixin from '@/Mixins/BaseInformation/PhoneMixin';
import StationMixin from '@/Mixins/BaseInformation/StationMixin';
import CancelReasonMixin from '@/Mixins/BaseInformation/CancelReasonMixin';
import DispatchCodeMixin from '@/Mixins/BaseInformation/DispatchCodeMixin';
import PhoneOnlineLocationMixin from '@/Mixins/BaseInformation/PhoneOnlineLocationMixin';
import StationCoverageZoneMixin from '@/Mixins/BaseInformation/StationCoverageZoneMixin';
import OtherOrganizationMixin from '@/Mixins/BaseInformation/OtherOrganizationMixin';
import MissionMixin from '@/Mixins/Mission/MissionMixin.js';
import MissionPhonesMixin from '@/Mixins/Mission/MissionPhonesMixin';
import MissionLackOFCodeMixin from '@/Mixins/Mission/MissionLackOfCodeMixin.js';
import missionOtherOrganizationInformMixin from '@/Mixins/Mission/MissionOtherOrganizationInformMixin.js';
import missionOtherOrganizationRequestMixin from '@/Mixins/Mission/MissionOtherOrganizationRequestMixin.js';
import CryptoJS from 'crypto-js';

export default {
  name: 'NewMissionWithMap800',
  title: 'ماموریت های جدید 800',
  inject: ['load'],
  components: {
    LMap,
    LMarker,
    LPolygon,
    LControl,
    LTooltip,
    LTileLayer,
    confirmDialog,
    TerminehModal,
    AlertComponent,
    MapSearchField,
    AppConversation,
    'v-popup': LPopup,
  },
  mixins: [
    snackBar,
    MapMixin,
    CallMixin,
    ZoneMixin,
    MapHelper,
    SharedMap,
    PhoneMixin,
    ShearedMixin,
    MissionMixin,
    StationMixin,
    TerminehMixin,
    ShearedHelper,
    SerachMapMixin,
    Mission800HelperNewWithMap,
    CancelReasonMixin,
    DispatchCodeMixin,
    MissionPhonesMixin,
    UserNotificationMixin,
    MissionLackOFCodeMixin,
    OtherOrganizationMixin,
    StationCoverageZoneMixin,
    PhoneOnlineLocationMixin,
    missionOtherOrganizationInformMixin,
    missionOtherOrganizationRequestMixin,
  ],
  created() {
    Vue.prototype.$mainSignalr.start();
    Vue.prototype.$mobileSignalr.start();
    this.$root.$refs.NewMissionWithMap800 = this;

    this.throttledTopList800 = throttle(this.fTopList800, 1500, {
      leading: true,
      trailing: true,
    });

    this.throttledNewMissionList800 = throttle(this.fNewMission800, 1500, {
      leading: true,
      trailing: true,
    });

    try {
      this.$mainSignalr.bus.$on('TopList800', this.throttledTopList800);
      this.$mobileSignalr.bus.$on('TopList800', this.throttledTopList800);
      this.$mainSignalr.bus.$on('NewMission800', this.throttledNewMissionList800);
      this.$mobileSignalr.bus.$on('NewMission800', this.throttledNewMissionList800);
    } catch (error) {
      console.log("error mainSignalr:", error);
    }
  },
  mounted() {
    this.mounteLoding();
    this.loadVoicesFromStorage();
    this.setMapBaseSystemSetting();
    this.getSystemSettingByClientComputer();
    window.addEventListener('keydown', this.handleFunctionKeys);
    this.mapInterval = setInterval(() => {
      const saved = localStorage.getItem('selectMissonState');
      let bytes = CryptoJS.AES.decrypt(localStorage.getItem('dash'), 'f9rr8Y2D96Klh87N');
      let moduleId = '';
      if (bytes.sigBytes != 0) {
        moduleId = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      } else {
        moduleId = '';
      }
      if (moduleId != 2 || saved != "true") {
        window.close();
      }
    }, 4000);
  },
  data() {
    return {
      searchTextCode_Attach: '',
      silentTopListSound_A: false,
      clickItem: null,
      tempvalue: null,
      currentZoom: 12,
      showParagraph: false,
      withPopup: latLng(30.2839, 57.0834),
      withTooltip: latLng(30.2839, 57.0834),
      currentCenter: latLng(30.2839, 57.0834),
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      movingIconForPhoneWithMission: require('@/assets/images/phoneWithMission.svg'),
      movingIconForPhoneWithOutMission: require('@/assets/images/phoneWithOutMission.svg'),
      movingIconForGPSWithMission: require('@/assets/images/gpsWithMission.svg'),
      movingIconForGPSWithOutMission: require('@/assets/images/gpsWithOutMission.svg'),
      stopIconForPhoneWithMission: require('@/assets/images/stopphoneWithMission.svg'),
      stopIconForPhoneWithOutMission: require('@/assets/images/stopphoneWithOutMission.svg'),
      stopIconForGPSWithMission: require('@/assets/images/stopgpsWithMission.svg'),
      stopIconForGPSWithOutMission: require('@/assets/images/stopgpsWithOutMission.svg'),
      dragging: false,
      icon: this.getIcon,
      patientIcon: L.divIcon({
        html: `<div class="map-icon-ripple"></div>
        <img src="${require('@/assets/images/mapMarkerRadius.svg')}" alt="patient-marker"/>`,
        className: 'map-icon-container',
        iconSize: [30, 30],
        iconAnchor: [0, 0],
      }),
      //Dispatch
      position: [],
      mapInterval: null,
      locationInterval: null, // 4s vehicle-position poll (cleared in beforeDestroy)
      fenceCoords: [],
      tempFenceCoords: [],
      fenceFlag: true,
      searchZoneIds: [],
      searchAddress: '',
      searchCode: '',
      allPhonesPositions: [],
      counter: 0,
      topListRefreshInFlight: false,
      topListRefreshPending: false,
    };
  },
  beforeDestroy() {
    this.unbind800DispatchMapClick();
    this.clearSoundInterval();
    this.cleanupResources();
    clearInterval(this.mapInterval);
    clearInterval(this.locationInterval);
    window.removeEventListener('keydown', this.handleFunctionKeys);
    try {
      this.$mainSignalr.bus.$off('NewMission800', this.throttledNewMissionList800);
      this.$mobileSignalr.bus.$off('NewMission800', this.throttledNewMissionList800);
      this.$mainSignalr.bus.$off('TopList800', this.throttledTopList800);
      this.$mobileSignalr.bus.$off('TopList800', this.throttledTopList800);
    } catch (error) {
      console.log("error mainSignalr: ", error);
    }



    delete this.$root.$refs.NewMissionWithMap800;
  },
  methods: {
    openAttachmentModal() {
      this.searchTextCode_Attach = '';
      this.showCurrentMissionAttachmentModal();
    },
    startsWithFilter(item, queryText, itemText) {
      return itemText.toLowerCase().startsWith(queryText.toLowerCase())
    },
    handleAlarmTopListManual() {
      this.topListSoundStop = true;
      this.silentTopListSound = !this.silentTopListSound;
    },
    handleFunctionKeys(e) {
      const keyActions = {
        F9: () => this.handleSubmitForms(),
      };

      if (keyActions[e.key] && this.sendTOPhoneModal) {
        e.preventDefault();
        keyActions[e.key]();
      }
    },
    handleSubmitForms() {
      this.sendMissionToPhoneCheckType();
    },
    handleEnterLack() {
      this.$nextTick(() => {
        if (this.selectedMissionLakeCode) {
          this.addMissionLakeCode();
        }
      });
    },
    getVehicleIcon(title) {
      const icons = {
        // 'آمبولانس': 'mdi-ambulance',
        'بالگرد': 'mdi-helicopter',
        'موتور': 'mdi-motorbike',
        'اتوبوس': 'mdi-bus',
        'شناور': 'mdi-ferry',
      };

      if (icons[title]) {
        return icons[title];
      }

      for (const [key, icon] of Object.entries(icons)) {
        if (title.includes(key)) {
          return icon;
        }
      }

      return 'mdi-ambulance';
    },
    handleIconLocation: function (locationState) {
      if (locationState == 1) {
        return { icon: 'mdi-map-marker-check', color: '#1EAA6E' };
      } else if (locationState == 2) {
        return { icon: 'mdi-map-marker', color: '#62736c' };
      } else {
        return { icon: 'mdi-map-marker-off', color: '#cdcdcd' };
      }
    },
    mounte: function () {
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('@/assets/images/marker-icon-2x.png'),
        iconUrl: require('@/assets/images/marker-icon.png'),
        shadowUrl: require('@/assets/images/marker-shadow.png'),
      });
      this.refreshTopList(true, true)
      this.getAllZones();
      this.getAllUniversities();
      //
      this.getAllStationCoverageZonesForAllStations();
      this.getAllPhoneOnlineLocationFunction();
      this.getSystemSettingByClientComputer();
      this.setMapBaseSystemSetting();
      this.getAllStations();
      // stored so beforeDestroy can stop it — the old bare setInterval kept
      // polling forever after the component was destroyed
      this.locationInterval = setInterval(() => this.getAllPhoneOnlineLocationFunction(), 4000);
      this.$mainSignalr.bus.$on('Location', this.fLocation);
    },
    getData: function () {
      this.refreshTopList(true, false);
    },
    fTopList800: function () {
      if (!this.silentTopListSound) {
        this.playSound3();
      }
      this.refreshTopList(false, false);
    },
    fNewMission800: function () {
      this.topListSoundStop = this.silentTopListSound;
      this.refreshTopList(true, false);
    },

    refreshTopList: async function (needSound, needRefresh) {
      if (this.topListRefreshInFlight) {
        this.topListRefreshPending = true;
        return;
      }
      this.topListRefreshInFlight = true;
      try {
        await this.getListOfMissionsForDispatchTopListFunction(needSound, needRefresh);
      } catch (error) {
        console.log('refreshTopList error:', error);
      } finally {
        this.topListRefreshInFlight = false;
        if (this.topListRefreshPending) {
          this.topListRefreshPending = false;
          this.refreshTopList(needSound, needRefresh);
        }
      }
    },

    onGetAllUserNotificationOnSignal: function () {
      this.getAllUserNotificationsOnSignal();
    },
    invokeToCodeInMap: function (value, data) {
      this.selectedRow = data.item?.id;
      this.clickItem = value;
      const connection = Vue.prototype.$mainSignalr?.connection;
      if (!connection || connection.state !== 'Connected') {
        console.warn('[SignalR2] connection not ready');
        return;
      }
      connection.invoke('Location', data.item.ambulanceCode.toString()).catch((err) => {
        console.error('[SignalR2] invoke Location failed:', err);
      });
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    mapInvalidate: function () {
      setTimeout(() => {
        this.$refs.modalmap.mapObject.invalidateSize();
      }, 100);
    },
    getMovingIcon(data) {
      // pick the right image for the vehicle's source/state (same logic as before,
      // collapsed so the icon geometry is defined in exactly ONE place)
      let iconUrl;
      let angle = 0;
      if (data.speed >= 2) {
        angle = data.angle; // moving: rotate the arrow to the heading
        if (data.isPhoneLocation == true) {
          if (data.hasMission == true) iconUrl = this.movingIconForPhoneWithMission;
          else if (data.hasMission == false) iconUrl = this.movingIconForPhoneWithOutMission;
        } else if (data.isPhoneLocation == false) {
          if (data.hasMission == true) iconUrl = this.movingIconForGPSWithMission;
          else if (data.hasMission == false) iconUrl = this.movingIconForGPSWithOutMission;
        }
      } else if (data.speed < 2) {
        if (data.isPhoneLocation == true) {
          if (data.hasMission == true) iconUrl = this.stopIconForPhoneWithMission;
          else if (data.hasMission == false) iconUrl = this.stopIconForPhoneWithOutMission;
        } else if (data.isPhoneLocation == false) {
          if (data.hasMission == true) iconUrl = this.stopIconForGPSWithMission;
          else if (data.hasMission == false) iconUrl = this.stopIconForGPSWithOutMission;
        }
      }
      if (!iconUrl) return; // parity with the old code: unknown state -> default marker

      return L.divIcon({
        // OWN class with clean CSS below — the shared global 'my-custom-pin' class
        // carries styles that displace the img from its Leaflet anchor box, which
        // is why the tooltip appeared far from the visible pin
        className: 'vehicle-map-pin',
        html: `<img src="${iconUrl}" style="width:20px; height:20px; transform:rotate(${angle}deg)"/>`,
        iconSize: [20, 20],
        iconAnchor: [10, 10],     // center of the 20x20 img sits ON the coordinate
        tooltipAnchor: [40, -10],  // tooltip hangs from the icon's TOP-CENTER (used with direction:'top')
        popupAnchor: [0, -10],    // popup tip opens just above the img
      });
    },
    //Dispatch
    stationIcon: function () {
      return L.divIcon({
        className: 'my-custom-pin',
        html: '<img src="/icons/map/ems_logo.svg" style="width:28px; height:28px;"/>',
        // explicit geometry so the popup opens on the icon, not offset from it
        iconSize: [28, 28],
        iconAnchor: [14, 14],
        popupAnchor: [0, -14],
      });
    },
    getDateDifference: function (fromDate) {
      const nowSeconds = new Date()?.getTime();
      const fromDateSecondes = new Date(fromDate)?.getTime();
      const difference = Math.abs(nowSeconds - fromDateSecondes);
      return this.convertSecondsToHHMMss(difference / 1000);
    },
    getPopUpInfoList: function (item) {
      return [
        {
          id: 2,
          title: 'وضعیت فعلی',
          value: item?.phone?.currentStatus,
        },
        {
          id: 3,
          title: 'زمان آخرین تراکنش',
          value: this.getDateDifference(item?.locationDateTime),
        },
      ];
    },
    readyFencesForMap: function (data) {
      this.fenceCoords = [];
      for (let i = 0; i < data.length; i++) {
        let tempFence = {
          latlngs: [],
          color: data[i].fenceColor,
          moreInfo: [],
          id: data[i].id,
          title: data[i].title,
        };
        for (let j = 0; j < data[i].stationCoverageZoneFences.length; j++) {
          let info = [];
          info.push(data[i].stationCoverageZoneFences[j].latitude);
          info.push(data[i].stationCoverageZoneFences[j].longitude);
          tempFence.latlngs.push(info);
        }
        for (let j = 0; j < data[i].stationCoverageZoneSupportStations.length; j++) {
          let title = data[i].stationCoverageZoneSupportStations[j].station
            ? data[i].stationCoverageZoneSupportStations[j].station.title
            : '-';
          tempFence.moreInfo.push({
            title: title,
            id: data[i].stationCoverageZoneSupportStations[j].id,
          });
        }
        this.fenceCoords.push(tempFence);
      }
    },
    showHideFence: function () {
      if (this.sendTOPhoneModal) {
        this.toggle800FenceVisibility();
        return;
      }

      if (this.fenceFlag == true) {
        this.fenceFlag = false;
        this.tempFenceCoords = [];
        for (let i = 0; i < this.fenceCoords.length; i++) {
          this.tempFenceCoords.push(this.fenceCoords[i]);
        }
        this.fenceCoords = [];
      } else if (this.fenceFlag == false) {
        this.fenceFlag = true;
        this.fenceCoords = [];
        for (let i = 0; i < this.tempFenceCoords.length; i++) {
          this.fenceCoords.push(this.tempFenceCoords[i]);
        }
        this.tempFenceCoords = [];
      }
    },
    readyCodeData: function () {
      this.allPhonesPositions = [];
      if (this.searchZoneIds.length > 0) {
        for (let i = 0; i < this.searchZoneIds.length; i++) {
          for (let j = 0; j < this.allPhoneOnlineLocations.length; j++) {
            if (this.searchZoneIds[i] == this.allPhoneOnlineLocations[j].phone.zoneId) {
              this.allPhonesPositions.push(this.allPhoneOnlineLocations[j]);
            }
          }
        }
      } else {
        this.allPhonesPositions = this.allPhoneOnlineLocations;
      }
    },
    searchForCode: function () {
      if (this.searchCode) {
        let searchObject = this.allPhoneOnlineLocations.find(
          (c) => c.phone.code == this.searchCode,
        );
        this.$refs.modalmap.mapObject.flyTo([searchObject.latitude, searchObject.longitude], 16);
      } else {
        this.clearSearchCode();
      }
    },
    clearSearchCode: function () {
      const lat = this.$store.state.SystemSettingModule.systemSetting?.mapCenterLatitude;
      const lng = this.$store.state.SystemSettingModule.systemSetting?.mapCenterLongitude;
      const zoom = this.$store.state.SystemSettingModule.systemSetting?.mapDefaultZoomLevel;
      if (lat && lng) {
        this.$refs.modalmap.mapObject.flyTo([lat, lng], zoom ?? 12);
      }
    },
    searchForAddress: function () {
      if (this.searchAddress) {
        this.getMapGeoCode(this.searchAddress);
      } else {
        this.clearSearchCode();
      }
    },
    goToAddress: function (data) {
      this.$refs.modalmap.mapObject.flyTo([data.longitude, data.latitude], 16);
    },
    flyToCode: function (data) {
      console.log(data);
    },
    fLocation(data) {
      if (this.$store.state.userModule.userId == data?.data?.userId) {
        for (const item of this.allPhonesPositions) {
          if (data?.data?.code == item.phone.code) {
            this.$refs.modalmap.mapObject.flyTo([item.latitude, item.longitude], 17);
          }
        }
      }
    },
  },
  computed: {
    silentTopListSound: {
      get() {
        return this.silentTopListSound_A;
      },
      set(value) {
        this.silentTopListSound_A = value;
      }
    },
    attachallFilterList() {
      const list = [...this.allAttachment];
      let result = list;

      if (this.searchTextCode_Attach && this.searchTextCode_Attach.trim() !== '') {
        const searchLower = this.searchTextCode_Attach.toLowerCase().trim();
        result = result.filter((u) => {
          return (u.code?.toLowerCase().includes(searchLower));
        });
      }

      return result;
    }
  }
};
</script>

<style scoped>
::v-deep .leaflet-popup-content {
  margin: 0px 15px 0px 10px !important;
}

.itemCallStyle {
  min-height: 30px !important;
  height: 30px !important;
  padding: 0 6px;
}

.custom-height-30>>>.v-input__control {
  min-height: 30px !important;
  height: 30px !important;
}

.custom-height-30>>>.v-input__slot {
  min-height: 30px !important;
  height: 30px !important;
  padding: 0 12px !important;
}

.custom-height-30>>>.v-select__slot {
  height: 100% !important;
  align-items: center !important;
}

.custom-height-30>>>input {
  max-height: 26px !important;
  padding: 0 0 2px 0 !important;
  margin: 0 !important;
  font-size: 14px !important;
}

.custom-height-30>>>.v-input__append-inner,
.custom-height-30>>>.v-input__prepend-inner {
  margin-top: 0 !important;
  align-self: center !important;
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
}

.custom-height-30>>>.v-input__slot label {
  top: 5px !important;
  font-size: 14px !important;
}

.custom-height-30.v-input--is-label-active>>>.v-input__slot label,
.custom-height-30.v-input--is-focused>>>.v-input__slot label {
  transform: translateY(-13px) scale(0.75) !important;
  background: white;
  padding: 0 4px !important;
}

.custom-height-30>>>.v-input__append-inner .v-icon {
  font-size: 19px !important;
}

.custom-autocomplete-item .item-code {
  font-weight: 600;
  color: #000029;
  font-size: 16px;
  unicode-bidi: embed;
  direction: ltr;
}
</style>

<style lang="scss" scoped>
.mission_ongoing_800 {
  height: calc(100vh - 1px);
  background: #fff5f3;

  .mainBox {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    // gap: 10px;

    .listitemsBox {
      flex: 1 0 calc(27%);
      max-width: 400px !important;
      min-width: 350px !important;
      background: #ffffff;
      box-shadow: 0px 4px 4px 0px #00000040;
      padding-bottom: 13px;
      padding-top: 13px;

      .reloadApi {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 5px;
        margin-bottom: 12px;
        padding: 0 19px 0 13px;
        cursor: pointer;

        .s1 {
          color: #943a2d;
          font-size: 15px;
          font-weight: 400;
        }
      }

      .list {
        padding: 0 10px 0 3px;
        overflow: auto;
        height: calc(100% - 33px);

        .item {
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 10px;
          padding: 12px;
          border: 1px solid #1eaa6e;
          border-radius: 8px;
          margin-bottom: 8px;
          transition: all 0.3 ease-in-out;
          cursor: pointer;

          &:hover {
            background: #f0f0f0;
          }

          .titleTop {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 5px;
            padding: 4px 6px;
            background: #1e33aa;
            border-radius: 15px 0 0 15px;
            position: relative;
            right: -21px;
            width: calc(100% + 25px);

            &::after {
              content: '';
              position: absolute;
              top: 100%;
              right: -1px;
              width: 0;
              height: 0;
              border: 0 solid transparent;
              border-width: 9px 0 0 11px;
              transform: rotate(270deg);
              border-top-color: #12006e;
            }

            &.whiteStyle::after {
              border-top-color: #909090;
            }

            &.greenStyle::after {
              border-top-color: #319d5f;
            }

            &.yellowStyle::after {
              border-top-color: #b38c21;
            }

            &.redStyle::after {
              border-top-color: #bb4646;
            }

            .txt1 {
              font-size: 14px;
              font-weight: 500;
              color: white;
            }

            .iconNum {
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 50%;
              background: #ffffff33;
              position: relative;
              width: 25px;
              height: 25px;
              min-width: 25px;
              min-height: 25px;
              margin-right: auto;

              .tNum {
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 50%;
                background: #ffffff;
                position: absolute;
                top: -2px;
                right: -3px;
                font-family: Arial !important;
                min-width: 10px;
                min-height: 10px;
                width: fit-content;
                height: fit-content;
                line-height: 1;
                padding: 1px;
                font-family: Arial;
              }

              span {
                font-size: 10px;
                font-weight: 400;
                color: #1eaa6e;
              }
            }

            .txt3 {
              font-size: 12px;
              font-weight: 400;
              color: #ffffff;
              font-family: Arial;
            }
          }

          .suggIconBox {
            display: flex;
            justify-content: left;
            align-items: center;
            gap: 5px;
            margin-right: auto;
          }

          .txtAddress {
            .icons {
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              gap: 4px;
              float: right;
              height: 16px;
              margin-left: 5px;

              .txt1 {
                background: #dbd9d2;
                border-radius: 4px;
                padding: 2px 4px;
                color: black;
                font-family: Arial !important;
                font-size: 9px;
              }
            }

            .txt2 {
              font-size: 13px;
              font-weight: 400;
              color: black;
              margin: 0;
              text-align: right;
            }
          }

          .txtDetil {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 4px;

            .txt1 {
              font-size: 13px;
              font-weight: 400;
              color: black;
              font-family: Arial !important;
            }
          }

          .moreDetil {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 2px;

            .txtUser,
            .txtZone {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              gap: 4px;
              flex: 1;
            }
          }
        }
      }

      .emptyList {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: auto;
      }

      .selectItemList {
        padding: 0 14px 0 8px;
        overflow: auto;
        height: calc(100% - 33px);

        .item {
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 10px;
          padding: 12px 9px;
          border: 1px solid #1eaa6e;
          border-radius: 8px;
          margin-bottom: 8px;
          transition: all 0.3s ease-in-out;

          .titleTop {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 4px;
            padding: 4px 6px;
            background: #1e33aa;
            border-radius: 15px 0 0 15px;
            position: relative;
            right: -21px;
            width: calc(100% + 25px);

            &::after {
              content: '';
              position: absolute;
              top: 100%;
              right: -1px;
              width: 0;
              height: 0;
              border: 0 solid transparent;
              border-width: 9px 0 0 11px;
              transform: rotate(270deg);
              border-top-color: #12006e;
            }

            &.whiteStyle::after {
              border-top-color: #909090;
            }

            &.greenStyle::after {
              border-top-color: #319d5f;
            }

            &.yellowStyle::after {
              border-top-color: #ff6600;
            }

            &.redStyle::after {
              border-top-color: #bb4646;
            }

            .txt1 {
              font-size: 13px;
              font-weight: 500;
              color: white;
              margin-left: 4px;
            }

            .iconNum {
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 50%;
              background: #ffffff33;
              position: relative;
              width: 25px;
              height: 25px;
              min-width: 25px;
              min-height: 25px;
              margin-right: auto;

              .tNum {
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 50%;
                background: #ffffff;
                position: absolute;
                top: -2px;
                right: -3px;
                font-family: Arial !important;
                min-width: 10px;
                min-height: 10px;
                width: fit-content;
                height: fit-content;
                line-height: 1;
                padding: 1px;
                font-family: Arial;
              }

              span {
                font-size: 10px;
                font-weight: 400;
                color: #1eaa6e;
              }
            }

            .txt3 {
              font-size: 13px;
              font-weight: 400;
              color: #ffffff;
              font-family: Arial;
            }
          }

          .txtAddress {
            .icons {
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              gap: 4px;
              float: right;
              height: 16px;
              margin-left: 5px;

              .txt1 {
                background: #dbd9d2;
                border-radius: 4px;
                padding: 2px 4px;
                color: black;
                font-family: Arial !important;
                font-size: 10px;
              }
            }

            .txt2 {
              font-size: 13px;
              font-weight: 400;
              color: black;
              margin: 0;
              text-align: right;
            }
          }

          .txtDetil {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 4px;

            .txt1 {
              font-size: 13px;
              font-weight: 400;
              color: black;
              font-family: Arial !important;
            }

            .txt2 {
              font-size: 13px;
              font-weight: 400;
              color: black;
              margin: 0;
              text-align: right;
            }

            .txt3 {
              font-size: 13px;
              font-weight: 400;
              color: #404040;
              margin: 0;
              text-align: right;
            }
          }

          .txtComplaint {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            gap: 4px;

            .txt2 {
              font-size: 13px;
              font-weight: 500;
              color: black;
              margin: 0;
              text-align: right;
            }

            .txt3 {
              font-size: 13px;
              font-weight: 400;
              color: #555555;
              margin: 0;
              text-align: right;
            }
          }

          .moreDetil {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 2px;

            .txtUser,
            .txtZone {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              gap: 4px;
              flex: 1;
            }
          }

          .btnSubmitToPhone {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 6px;

            .inputCode {
              flex: 1 1 68%;
            }

            .btnSubmit {
              flex: 1 1 29%;
              min-width: unset !important;
              font-size: 13px !important;

            }
          }

          .send-mission-detail-card {
            // border: 1px solid var(--dark-color) !important;
            border: 1px solid #79747E80 !important;
            min-height: 125px !important;
          }

          .send-mission-detail-card-body {
            height: 10vh !important;
            overflow-y: auto !important;
            min-height: 100px;
          }

          .send-mission-title-content {
            color: #6c6c6c !important;
            font-weight: 500;
            font-size: 12px;
            background: white !important;
            margin-top: -9px !important;
            margin-right: 10px !important;
            padding-left: 6px !important;
            padding-right: 6px !important;
          }
        }
      }

      .phoneBox {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 2px;
        flex-wrap: wrap;

        .txtPhone {
          font-size: 13px;
          font-weight: 400;
          color: var(--dark-color);
          font-family: Arial !important;
          cursor: pointer;
          transition: all 0.3s ease-in-out;

          &:hover {
            color: #00d0ff;
          }
        }
      }
    }

    .mapViewBox {
      flex: 4 0 calc(73% - 10px);
      display: flex;
      justify-content: start;
      align-items: start;
      flex-direction: column;
      gap: 3px;

      .filtersControl {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        padding: 8px;
        padding-bottom: 0;
        z-index: 11;

        >div {
          background: white;
          border-radius: 15px;
        }

        .itemSearch {
          flex: 2 1 40%;
        }

        .itemZone {
          flex: 1.5 1 35%;
        }

        .itemCode {
          flex: 1 1 25%;
        }
      }

      .mapBox {
        width: 100%;
        height: 100%;
        flex: 1 1 100%;
        z-index: 10;
      }
    }
  }

  .refresh-btn {
    animation-name: spin;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
}
</style>

<style>
/* Marker pin class for this map's vehicle icons.
   NOT scoped: Leaflet creates these elements outside Vue's scope attribute.
   Deliberately free of any position/margin/transform so the img stays exactly
   inside the icon box Leaflet anchors tooltips and popups to. */
.vehicle-map-pin {
  background: transparent;
  border: none;
}

.vehicle-map-pin img {
  display: block;
  /* kill inline-img baseline gap so the img fills the 20x20 box */
}
</style>
